<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jELMu5/tc-custom/9781600379185.jpg?1728851932762" alt="This image is the cover for the book Can I Have 5 Minutes of Your Time?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Can I Have 5 Minutes of Your Time?
      </h1>
      <p class="bookDescription body article font2">
        <b>This national bestselling book on sales strategies and techniques is a “fast read” because “Becker knows what he’s talking about” (<i>Business Week</i>).</b><br/><br/><i>Can I Have 5 Minutes of Your Time?</i> is one of the bestselling books on sales to come along in over twenty years. The ideas and concepts inside have been used by tens of thousands of people to increase their sales performance, from the novice to the seasoned professional. Hal Becker understands that hard work, common sense and close attention to customer needs are trademarks of a good salesman. His book echoes that same insight for those who want to achieve sales success.<br/><br/>A great training manual for anyone involved in sales.” —Allbusiness.com
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hal Becker
      </h2>
      
      <p class="authorDescription body article">Hal Becker is a nationally known expert on Sales, Customer Service, and Negotiating. He conducts seminars or consults to more than 140 organizations a year. His client list includes IBM, Disney, New York Life, Continental Airlines, Verizon, Terminix, AT&T, Pearle Vision, Cintas, and hundreds of other companies and associations. At the age of 22, he became the #1 salesperson among a national sales force of 11,000, for the Xerox Corporation. Six years later in 1983, he survived terminal cancer only months after launching Direct Opinions, one of America's first customer service telemarketing firms that facilitates more than two million calls per year with offices throughout the U.S.A. and Canada. In 1990, Hal sold Direct Opinions to devote time for consulting and presenting lectures around the world. He has been featured in publications including The Wall Street Journal, Business Week, Inc Magazine, Nations Business and hundreds of newspapers and Radio/TV stations around the world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?066fff63